module.exports = __webpack_public_path__ + "static/media/mz.c8308283.svg";